<template>
    <div>
        <div class="py-3 px-3 border-bottom d-flex justify-content-between">

            <div class="d-flex align-items-center">
                <div class="mr-3">
                    <span v-if="lesson.video_url">
                        <i class="fa fa-play-circle" title="Vídeo Aula"></i>
                    </span>
                    <span v-else>
                        <i class="fa fa-book" title="Texto"></i>
                    </span>
                </div>

                <a href="javascript:void(1)" @click="openPreview">
                    <h5 class="p-0 m-0">
                        {{ lesson.name }}
                    </h5>
                </a>

<!--                <div v-if="lesson.video_duration_human && lesson.ready && lesson.video_source" class="ml-2 font-weight-bold-500 text-muted">-->
<!--                    {{ lesson.video_duration_human }} de duração-->
<!--                </div>-->
            </div>

            <div>
                <!-- order up -->
                <a href="javascript:void(1)" @click="orderUp" class="ml-2 text-primary" title="Mover para cima">
                    <i class="fas fa-arrow-up"></i>
                </a>

                <!-- order down -->
                <a href="javascript:void(1)" @click="orderDown" class="ml-2 text-primary" title="Mover para baixo">
                    <i class="fas fa-arrow-down"></i>
                </a>

                <a href="javascript:void(1)" @click="openModalEditLesson" class="ml-2 text-primary" title="Editar Aula">
                    <i class="fas fa-edit"></i>
                </a>

                <a href="javascript:void(1)" @click="openModalDestroyLesson" class="ml-2 text-danger" title="Excluir Aula">
                    <i class="fas fa-trash"></i>
                </a>
            </div>
        </div>

        <!-- Edit Lesson -->
        <edit-lesson :module="module" :lesson="lesson" @updated="refresh"></edit-lesson>

        <!-- Destroy Lesson -->
        <destroy-lesson :module="module" :lesson="lesson" @destroyed="refresh"></destroy-lesson>

    </div>
</template>

<script>
import EditLesson from "./EditLesson";
import DestroyLesson from "./DestroyLesson";

export default {
    props: ['lesson', 'module'],
    components: {
        EditLesson,
        DestroyLesson
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        openPreview() {
            return window.location.href = 'modules/' + this.module.id + '/lesson/' + this.lesson.id;
            //this.$root.$emit('show-lesson-preview', this.lesson);
        },

        openModalEditLesson() {
            this.$root.$emit('open-modal-edit-lesson-' + this.lesson.id);
        },

        openModalDestroyLesson() {
            this.$root.$emit('open-modal-destroy-lesson-' + this.lesson.id);
        },

        refresh() {
            this.$emit('updated');
        },

        orderUp() {
            this.loading = true;
            axios.put('/teacher/courses/' + this.module.course_id + '/modules/' + this.module.id + '/lessons/' + this.lesson.id + '/order', {
                orderDirection: 'up'
            })
                .then(response => {
                    this.loading = false;
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                });
        },

        orderDown() {
            this.loading = true;
            axios.put('/teacher/courses/' + this.module.course_id + '/modules/' + this.module.id + '/lessons/' + this.lesson.id + '/order', {
                orderDirection: 'down'
            })
                .then(response => {
                    this.loading = false;
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped>

</style>
